/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Page_SubtitleInputs */



/**
* | output |
* | --- |
* | "Configure which capabilities your organization's members, teams and defaults are granted." |
*
* @param {Rights_Page_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_page_subtitle = /** @type {((inputs?: Rights_Page_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Page_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen für Mitglieder, Teams und Standardwerte der Organisation festlegen.")
	return /** @type {LocalizedString} */ ("Configure which capabilities your organization's members, teams and defaults are granted.")
});